import { util } from 'pevueglobal'
import {
  XVtableSetRowStateProperty,
  XVTablesort,
  XVtablecolumnsettingchanged,
  initXVtableState,
  addXVtableState
} from '../XVtableV2'
import { setXVtableMutations } from '../XVtable'
import { graphdata, getGraphUrl, setReportStatus, resetreportstatus, setGraphdata } from '../XVgraphcontrol.js'
import locStore from 'store2'
import { router } from '../../router'
let lstore = locStore.namespace('Spe026PrDetailPE')

// state
const state = {
  statusTargetberekening: null,
  settings: [],
  targetGegevens: [],
  subrules: [],
  subrulebuttons: [],
  pagesettings: {
    compchartvisible: false,
    comptablevisible: false
  },
  inputdata: {
    targetID: 0,
    autoNumID: 0,
    lastTarget: 0,
    showTitle: 0,
    showBackButton: 0
  },
  targetTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  subruleloaded: [],
  subruleOpen: false,
  competenceTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  competenceGraphdata: {
    graphlabels: [],
    graphwaarden: [],
    graphkleuren: [],
    compPoints: 0
  },
  competenceloaded: false,
  graphdata: []
}
// getters
const getters = {
  targetTable: state => state.targetTable,
  targetTableColumns: state => subRuleID =>
    state.targetTable.tablecolumnsetting.filter(c => c.uniqueIdentifier === subRuleID),
  statusTargetberekening: state => state.statusTargetberekening,
  settings: state => state.settings,
  targetGegevens: state => state.targetGegevens,
  subrules: state => state.subrules,
  subruleloaded: state => subRuleID => {
    let srl = state.subruleloaded.find(s => s.id === subRuleID)
    if (srl) {
      return srl
    } else {
      return { visible: false }
    }
  },
  subrulebuttons: state => tblProfGroupSubRuleID =>
    state.subrulebuttons.filter(srb => srb.tblProfgroupSubruleID === tblProfGroupSubRuleID),
  subruleOpen: state => state.subruleOpen,
  competenceTable: state => state.competenceTable,
  competenceGraphdata: state => state.competenceGraphdata,
  competenceloaded: state => state.competenceloaded,
  graphdata: graphdata('graphdata')
}
// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      96,
      198,
      204,
      210,
      631,
      635,
      656,
      657,
      1029,
      1030,
      1031,
      1422,
      2267,
      3321,
      3322,
      3663,
      3900,
      3908,
      3909,
      4578,
      4579,
      4580,
      4581,
      4582,
      10561,
      13791,
      13798,
      14449,
      15206,
      15381,
      15390,
      15392,
      15391,
      15402,
      15403,
      15404,
      15405,
      15406,
      15407,
      15408,
      15431,
      15432,
      16008,
      16009,
      16584,
      16585,
      18849
    ]
    dispatch('gettranslations', textIDs, { root: true })
  },
  getGraphUrl: getGraphUrl('setReportStatus'),
  getStatus: async ({ commit, dispatch }) => {
    const statusDS = await util.getDataApi('prof/PEapi_SPE020_PR_StatusCheck')
    // 1 = nog een keer
    state.statusTargetberekening = statusDS.ds.data0[0].statusTargetberekening
    if (statusDS.ds.data0[0].statusTargetberekening === 1) {
      setTimeout(function() {
        dispatch('getStatus')
      }, 1000)
      // setTimeout(dispatch('getStatus'), 1000) -> dit gaf een error maar voluitgeschreven niet. (regels hier boven met setTimeout)
    } else {
      dispatch('getTargetsdetails')
    }
  },
  getTargetsdetails: async ({ commit, dispatch }) => {
    const targetsdetailsdata = await util.getDataApi('prof/PEapi_SPE026_PR_DetailPE', state.inputdata)
    state.statusTargetberekening = targetsdetailsdata.ds.data0[0].statusTargetberekening
    if (targetsdetailsdata.ds.data0[0].statusTargetberekening === 1) {
      dispatch('getStatus')
    } else {
      let redirectlink = targetsdetailsdata.ds.data1[0].redirectDirectlyTo
      if (targetsdetailsdata.ds.data1[0].redirectDirectlyTo !== null) {
        window.location = redirectlink
      }
      // text-id is niet altijd hetzelfde, dynamisch ophalen op deze manier:
      let spE060LinkTextID = targetsdetailsdata.ds.data2.filter(t => {
        return t.spE060LinkTextID !== null
      })
      let wizardDossierLinkTextID = targetsdetailsdata.ds.data2.filter(t => {
        return t.wizardDossierLinkTextID !== null
      })
      let wizardDossierLinkTextIDUniek = [...new Set(wizardDossierLinkTextID.map(item => item.wizardDossierLinkTextID))]
      let sPE060TextIDUniek = [...new Set(spE060LinkTextID.map(item => item.spE060LinkTextID))]
      // arrays samenvoegen door middel van "destructuring assignment syntax"
      let textIDs = [...sPE060TextIDUniek, ...wizardDossierLinkTextIDUniek]
      // dispatch voert hier al de functie gettranslations uit waarbij de array met text id's wordt meegegeven.
      dispatch('gettranslations', textIDs, { root: true })

      commit('setTargetDetail', targetsdetailsdata)
      // PE-24012 Target toont verkeerde activiteiten. datavariabelen worden eerst leeggemaakt zodat opnieuw de data wordt opgehaald. als er autonum in url staat.
      if (router.currentRoute.params.autonumID !== 0 && router.currentRoute.params.autonumID !== null) {
        commit('resetData')
      }
      let stateToggleSubrules = lstore.session('stateToggleSubrules')
      // standaard al uitgeklapt:
      if (!stateToggleSubrules) {
        if (targetsdetailsdata.ds.data2[0].tblProfgroupTargetIndicationShowSubruleOverview === 0) {
          targetsdetailsdata.ds.data3.forEach(s => {
            dispatch('getXVtable', s.tblProfGroupSubRuleID)
          })
          commit('toggleSubruleVisible', true)
        }
      } else {
        stateToggleSubrules.forEach(subruleID => {
          dispatch('getXVtable', subruleID)
        })
        commit('toggleSubruleFromSession')
      }

      const graphInput = {
        pagename: 'SPE026_PR_DetailPE.aspx',
        clientid: '',
        filters: [
          {
            key: 'personid',
            value: targetsdetailsdata.ds.data2[0].tblpersonid,
          },
          // Does not work bacause of dateformat in de DB procedure.
          // {
          //   key: 'startdate',
          //   datevalue: util.DateForDatabase(new Date(targetsdetailsdata.ds.data2[0].startdate)),
          // },
          {
            key: 'targetid',
            value: targetsdetailsdata.ds.data2[0].tblProfGroupTargetID,
          },
        ],
      }
      const [graphdata] = await Promise.all([
        util.getDataApi('allroles/PEapi_GraphControl_Get_Available_Graphs', graphInput)
      ])
      commit('setGraphdata', graphdata)
    }
  },
  getXVtable: async ({ commit, state }, tblProfGroupSubRuleID) => {
    if (!state.subruleloaded.some(s => s.id === tblProfGroupSubRuleID)) {
      let xvtableinput = {
        targetID: state.targetGegevens.tblProfGroupTargetID,
        subruleID: tblProfGroupSubRuleID,
        startDate: state.targetGegevens.startdate,
        endDate: state.targetGegevens.endDate,
        halfTermStartDate: state.targetGegevens.halfTermStartDate
      }
      state.subruleloaded.push({ id: tblProfGroupSubRuleID, visible: true })
      const xvtabledata = await util.GetXVTableData('prof/PEapi_SPE026_PR_DetailPE_XVTable', xvtableinput)
      commit('addXVtableState', { data: xvtabledata, uniqueIdentifier: tblProfGroupSubRuleID })
    }
  },
  getcompetence: async ({ commit, state }) => {
    if (state.competenceloaded === false) {
      let competenceinput = {
        targetID: state.targetGegevens.tblProfGroupTargetID,
        startDate: state.targetGegevens.startdate,
        endDate: state.targetGegevens.endDate,
        halfTermStartDate: state.targetGegevens.halfTermStartDate
      }
      const competencedata = await util.getDataApi('prof/PEapi_SPE026_PR_DetailPE_Comps', competenceinput)
      commit('setCompetencetablesettings')
      commit('setcompetencedetail', competencedata)
      commit('compInitXVtableState')
      state.competenceloaded = true
    }
  }
}
// mutations
const mutations = {
  setReportStatus: setReportStatus('graphdata'),
  resetreportstatus: resetreportstatus('graphdata'),
  setGraphdata: setGraphdata('graphdata'),
  ...setXVtableMutations('targetTable'),
  compXVtableSetRowStateProperty: XVtableSetRowStateProperty('competenceTable'),
  compXVTablesort: XVTablesort('competenceTable'),
  compXVtablecolumnsettingchanged: XVtablecolumnsettingchanged('competenceTable'),
  compInitXVtableState: initXVtableState('competenceTable'),
  compAddXVtableState: addXVtableState('competenceTable'),
  setTargetDetail(state, data) {
    state.settings = data.ds.data1[0]
    state.targetGegevens = data.ds.data2[0]
    state.subrules = data.ds.data3
    state.subrulebuttons = data.ds.data4
  },
  setpagesettings(state, pagesettings) {
    state.pagesettings = { ...state.pagesettings, ...pagesettings }
  },
  setinputdata(state, inputdata) {
    state.inputdata = { ...state.inputdata, ...inputdata }
  },
  setcompetencedetail(state, data) {
    state.competenceTable.tabledata = data.ds.data0
    state.competenceGraphdata.compPoints = data.ds.data2[0].sumAllCompPoints

    let getGraphlabels = []
    let getGraphWaarden = []
    let getGraphKleuren = []
    data.ds.data1.forEach(l => {
      getGraphlabels.push(l.name)
      getGraphWaarden.push(l.compPerc)
      getGraphKleuren.push('#' + l.tblCompetenceColor)
    })
    state.competenceGraphdata.graphlabels = getGraphlabels
    state.competenceGraphdata.graphwaarden = getGraphWaarden
    state.competenceGraphdata.graphkleuren = getGraphKleuren
    state.pagesettings.compchartvisible = true
  },
  toggleSubruleVisible(state, vis) {
    state.subruleOpen = vis
    let stateToggleSubrules = []
    state.subruleloaded.forEach(s => {
      if (vis === true) {
        s.visible = true
      } else {
        s.visible = false
      }
    })
    state.subrules.forEach(s => {
      if (vis === true) {
        stateToggleSubrules.push(s.tblProfGroupSubRuleID)
      } else {
        stateToggleSubrules.splice(stateToggleSubrules.indexOf(s.tblProfGroupSubRuleID), 1)
      }
    })
    lstore.session('stateToggleSubrules', stateToggleSubrules)
  },
  setsession(state, id) {
    let stateToggleSubrules = lstore.session('stateToggleSubrules')
    if (!stateToggleSubrules) {
      stateToggleSubrules = []
    }
    if (stateToggleSubrules.indexOf(id) === -1) {
      stateToggleSubrules.push(id)
    } else {
      stateToggleSubrules.splice(stateToggleSubrules.indexOf(id), 1)
    }
    lstore.session('stateToggleSubrules', stateToggleSubrules)
  },
  resetData() {
    state.subruleloaded = []
    state.targetTable.tabledata = []
  },
  resetCompetence() {
    state.competenceloaded = false
    state.pagesettings.compchartvisible = false
    state.pagesettings.comptablevisible = false
  },
  toggleSubruleFromSession() {
    let stateToggleSubrules = lstore.session('stateToggleSubrules')
    if (stateToggleSubrules) {
      stateToggleSubrules.forEach(id => {
        state.subruleloaded.push({ id: id, visible: true })
      })
    }
  },
  setCompetencetablesettings(state) {
    state.competenceTable.tablesetting = {
      alwaysShowDetail: null,
      tableName: 'PersonActsComps',
      paging: 1,
      pagingSize: 50,
      procedure: 'PEapi_SPE026_PR_DetailPE_Comps',
      sequence: 1,
      sortable: 1
    }
    state.competenceTable.tablecolumnsetting = [
      {
        columnname: 'Datum',
        helpTextID: null,
        name: 'tblPersonActivityDateCompleted',
        headerTextID: 53,
        sequence: 1,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '100px',
        widthSM: '90px',
        widthXS: '90px',
        tableName: 'PersonActsComps',
        procedure: 'PEapi_SPE026_PR_DetailPE_Comps'
      },
      {
        columnname: 'Categorie',
        helpTextID: null,
        name: 'categoryname',
        headerTextID: 165,
        sequence: 2,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '15%',
        widthSM: null,
        widthXS: null,
        tableName: 'PersonActsComps',
        procedure: 'PEapi_SPE026_PR_DetailPE_Comps'
      },
      {
        columnname: 'Omschrijving',
        helpTextID: null,
        name: 'tblPersonPEActivityDescription',
        headerTextID: 20432,
        sequence: 3,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'PersonActsComps',
        procedure: 'PEapi_SPE026_PR_DetailPE_Comps'
      },
      {
        columnname: 'Competentie',
        helpTextID: null,
        name: 'compName',
        headerTextID: 4560,
        sequence: 4,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: '15%',
        widthSM: null,
        widthXS: null,
        tableName: 'PersonActsComps',
        procedure: 'PEapi_SPE026_PR_DetailPE_Comps'
      },
      {
        columnname: 'Punten',
        helpTextID: null,
        name: 'compPoints',
        headerTextID: 4582,
        sequence: 5,
        sortColumn: 'decCompPoints',
        sortable: 1,
        sortableDefault: 0,
        type: 'decimal',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: '75px',
        widthSM: null,
        widthXS: null,
        tableName: 'PersonActsComps',
        procedure: 'PEapi_SPE026_PR_DetailPE_Comps'
      }
    ]
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
